import React from 'react';
import { Calendar, User, Tag, Eye } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const PostHeaderContent = ({ post }) => {
  if (!post) return null;

  return (
    <header className="mb-8 md:mb-12">
      <div className="flex items-center text-sm text-muted-foreground mb-3 space-x-3">
        {post.category && <span className="flex items-center"><Tag className="w-4 h-4 mr-1.5 text-primary" /> {post.category}</span>}
        <span className="flex items-center"><Calendar className="w-4 h-4 mr-1.5 text-primary" /> {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
        {post.views !== undefined && <span className="flex items-center"><Eye className="w-4 h-4 mr-1.5 text-primary" /> {post.views} views</span>}
      </div>
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
        {post.title}
      </h1>
      {post.excerpt && <p className="text-lg md:text-xl text-muted-foreground mb-6">{post.excerpt}</p>}
      <div className="flex items-center space-x-4">
        <Avatar className="h-12 w-12 border-2 border-primary/50">
          <AvatarImage src={post.authorImage} alt={post.author} />
          <AvatarFallback>{post.author ? post.author.substring(0, 2).toUpperCase() : 'AU'}</AvatarFallback>
        </Avatar>
        <div>
          <p className="font-semibold text-foreground">{post.author}</p>
          <p className="text-sm text-muted-foreground">{post.authorRole} &bull; {post.readTime}</p>
        </div>
      </div>
    </header>
  );
};

export default PostHeaderContent;